import { copyToClipboard } from '@/services/util';
import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

interface CopyButtonProps {
  content: string;
  className?: string;
  disabled?: boolean;
  onCopied?: () => void;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  content,
  className,
  disabled = false,
  onCopied,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (disabled) return;
    const textToCopy = content;
    if (textToCopy) {
      const success = await copyToClipboard(textToCopy);
      if (success) {
        setCopied(true);
        onCopied?.();
        setTimeout(() => setCopied(false), 2000);
      }
    }
  };

  return (
    <button
      onClick={handleCopy}
      disabled={disabled}
      className={twMerge(
        'h-8 px-2 text-gray-200 hover:text-white bg-transparent border-none cursor-pointer flex items-center',
        disabled && 'opacity-50 cursor-not-allowed'
      )}
      aria-label={copied ? 'Copied' : 'Copy code'}
    >
      {copied ? (
        <Check className={twMerge('w-4 h-4', className)} />
      ) : (
        <Copy className={twMerge('w-4 h-4', className)} />
      )}
    </button>
  );
};

export default CopyButton;
